import { FETCH_REPORT_FS_LINES_REQUEST, FETCH_REPORT_FS_LINES_SUCCESS, FETCH_REPORT_FS_LINES_FAILURE } from './actions';

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const reportFSLinesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_REPORT_FS_LINES_REQUEST:
            return { ...state, loading: true };
        case FETCH_REPORT_FS_LINES_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case FETCH_REPORT_FS_LINES_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default reportFSLinesReducer;
